exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Address {\r\n  color: #222 !important;\n}\n.Address .van-picker {\r\n  height: 100% !important;\n}\n.Address .wux-select__button--confirm,\r\n.Address .wux-select__button--cancel,\r\n.Address .wux-select__title {\r\n  font-size: 15px !important;\n}\n.Address .van-radio__icon--round .van-icon{\r\n  border:1px solid #1989fa !important;\n}\r\n", ""]);

// exports
